// Design tokens. Source of truth for color, shadow, and spacing primitives.
// See DESIGN.md for the brand-anchor doctrine these tokens implement.
//
// Don't add inline hex values elsewhere in the client — extend this file
// instead so the design system stays grep-able.

export const C = {
  green: "#1A5E3A", greenDark: "#0F3D24", greenLight: "#2E7D5A",
  greenPale: "#EBF5EE", greenMid: "#B8D9C2",
  cream: "#F7F4EF", sand: "#EDE8DF", white: "#FFFEF9",
  charcoal: "#1C1917", grey: "#78716C", greyLight: "#C4BFB8",
  border: "#E7E2D9",
  gold: "#B8860B", goldPale: "#FEF9E7", amber: "#D97706",
  teal: "#0D6E63", tealPale: "#E6F4F2",
  sh: "0 2px 12px rgba(26,94,58,0.08)",
  shMd: "0 6px 24px rgba(26,94,58,0.12)",
  shLg: "0 16px 48px rgba(26,94,58,0.16)",
};

// Radius scale — shared across web surfaces.
// inner (12) fits concentrically inside card (16) with equal visual gap.
export const radius = {
  card: 16,
  sheet: 24,
  capsule: 99,
  inner: 12,
};

// Solid surface tokens — guaranteed legible. Use for dense content.
// Never blur ingredient rows, shopping rows, cook steps, or retailer tables.
export const surface = {
  base:     { background: C.cream },
  card:     { background: C.white, boxShadow: C.sh },
  grouped:  { background: C.sand },
  elevated: { background: C.white, boxShadow: C.shMd },
};

// Glass surface tokens — "Glass at the edges. Clarity at the centre."
// Each token has a .style (blur) and .fallback (opaque) variant.
// Use fallback when: no backdrop-filter support, prefers-reduced-transparency,
// or forced-colors. See src/glass.css for className-based equivalents with
// @supports and @media fallbacks wired automatically.
//
// Usage: style={{ ...glass.nav.style }}
// With fallback: style={{ supportsBlur ? glass.nav.style : glass.nav.fallback }}
export const glass = {
  nav: {
    style:    { background: "rgba(247,244,239,0.80)", backdropFilter: "blur(20px) saturate(180%)", WebkitBackdropFilter: "blur(20px) saturate(180%)" },
    fallback: { background: C.cream },
  },
  sheet: {
    style:    { background: "rgba(255,254,249,0.85)", backdropFilter: "blur(24px) saturate(160%)", WebkitBackdropFilter: "blur(24px) saturate(160%)" },
    fallback: { background: C.white },
  },
  control: {
    style:    { background: "rgba(247,244,239,0.70)", backdropFilter: "blur(12px) saturate(140%)", WebkitBackdropFilter: "blur(12px) saturate(140%)" },
    fallback: { background: C.cream },
  },
};
